import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
import { Button } from "components/bootstrap";
const Container = styled.div`
  margin: 0 0 35px;
`;
const AdditionalFieldsContent = styled.div(
  ({ $visible }) => css`
    display: ${$visible ? "block" : "none"};
    padding: 0 100px 0 25px;
  `
);
const ToggleAdditionalFields = styled(Button)`
  border: 0;
  display: block;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
`;
const AdditionalFields = ({
  children,
  className = void 0,
  onToggle = () => {
  },
  title,
  visible = false
}) => {
  const [fieldsVisible, setFieldsVisible] = useState(visible);
  const handleToggle = () => {
    setFieldsVisible(!fieldsVisible);
    onToggle(!fieldsVisible);
  };
  return /* @__PURE__ */ React.createElement(Container, { className }, /* @__PURE__ */ React.createElement(ToggleAdditionalFields, { bsStyle: "link", bsSize: "xsmall", onClick: handleToggle, type: "button" }, title, " ", /* @__PURE__ */ React.createElement(Icon, { name: fieldsVisible ? "keyboard_arrow_down" : "chevron_right" })), /* @__PURE__ */ React.createElement(AdditionalFieldsContent, { $visible: fieldsVisible }, children));
};
export default AdditionalFields;
